import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaTipoResposta = (): TabelaColuna => ({
  Chave: 'tipoResposta',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Tipo Resposta</div>
})
